import { render, staticRenderFns } from "./Baths.vue?vue&type=template&id=16947c12&scoped=true"
import script from "./Baths.vue?vue&type=script&lang=js"
export * from "./Baths.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16947c12",
  null
  
)

export default component.exports